// SPDX-License-Identifier: AGPL-3.0-only

import type { DateTimeFormatPreference } from "../api/user-settings.js";

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

function formatIsoLocal(date: Date, includeTime: boolean): string {
  const datePart: string = [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join("-");
  if (!includeTime) {
    return datePart;
  }
  return `${datePart} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function formatDateTime(
  value: string | null,
  preference: DateTimeFormatPreference,
): string {
  if (value === null) {
    return "—";
  }

  const date: Date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  if (preference === "iso_local") {
    return formatIsoLocal(date, true);
  }
  if (preference === "date_only") {
    return formatIsoLocal(date, false);
  }
  if (preference === "de_24h") {
    return new Intl.DateTimeFormat("de-DE", {
      dateStyle: "medium",
      timeStyle: "medium",
      hour12: false,
    }).format(date);
  }
  if (preference === "us_12h") {
    return new Intl.DateTimeFormat("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
      hour12: true,
    }).format(date);
  }
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "medium",
  }).format(date);
}
